import styled from 'styled-components'

const StyledHomeBanner = styled.div`
  padding: 50px 16px;
  text-align: center;
  background-color: ${({ theme }) => theme.color.gray[100]};

  h1 {
    font-size: 22px;
    color: ${({ theme }) => theme.color.gray[900]};
    font-weight: 600;
  }

  p {
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.color.gray[600]};
    max-width: 430px;
    margin: 12px auto 0 auto;
  }
`

export default StyledHomeBanner
